/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import { createStateHook, type HookStateFunction } from '@atlassian/react-sweet-state';
import { layoutStore } from '../../store/index.tsx';

export const usePreviewPanelState: HookStateFunction<
	{
		width: number;
	},
	void
> = createStateHook(layoutStore, {
	selector: (state) => ({
		...state.content.previewPanel,
	}),
});
